import { Loader2 } from "lucide-react";

export function PdfLoadingSkeleton() {
  return (
    <div className="flex h-full w-full flex-col bg-background">
      {/* Toolbar skeleton */}
      <div className="flex items-center gap-3 border-b border-border px-3 py-2">
        <div className="h-6 w-6 rounded bg-muted animate-pulse" />
        <div className="h-6 w-6 rounded bg-muted animate-pulse" />
        <div className="flex-grow" />
        <div className="h-6 w-20 rounded bg-muted animate-pulse" />
        <div className="flex-grow" />
        <div className="h-6 w-6 rounded bg-muted animate-pulse" />
        <div className="h-6 w-6 rounded bg-muted animate-pulse" />
      </div>

      <div className="flex flex-grow overflow-hidden">
        {/* Thumbnails skeleton */}
        <div className="h-full w-28 shrink-0 border-r border-border bg-muted/30 p-2">
          <div className="flex flex-col gap-2">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="aspect-[3/4] w-full rounded bg-muted animate-pulse"
              />
            ))}
          </div>
        </div>

        {/* Main canvas skeleton */}
        <div className="flex flex-grow items-center justify-center bg-muted/30">
          <div className="flex flex-col items-center gap-3">
            <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
            <span className="text-muted-foreground">Loading PDF…</span>
          </div>
        </div>
      </div>
    </div>
  );
}
